import { IMovementReason } from 'features/inventory/movements/reasons/types';
import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';

class MovementReasonService extends BaseService<IMovementReason> {
  constructor() {
    super('movement-types');
    this.canDelete = true;
  }

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const movementReasonService = new MovementReasonService();
